import { RotatingLines } from "react-loader-spinner";
import {
  EMPTY_STRING,
  inventoryConstants,
  toggleSwitchButtonConstants,
} from "../../../constants";
import { TRADING_CARD_CATEGORIES_ENUMS } from "../../../system/globalEnums";
import SimpleNumberField from "../../components/inputNumberField/SimpleNumberField";
import SelectDropDown from "../../components/selectDropdown/SelectDropdown";
import TableCustomHeader from "../../components/table/TableCustomHeader";
import {
  calculateRatio,
  decidePriceToUse,
  excludeNullColumns,
  calculateOfferPrices,
  getBatchModalGradeColumn,
  getBatchModalRarityColumn,
  getPresetStockPrice,
  getProductIfExist,
  getProductSubCategory,
  handleLockOrUnlockTradeItem,
  handleRaritiesChange,
  isMarketPriceHigh,
  isSystemProduct,
  onChangeProductCondition,
  parseToDecimalNumber,
  parseToThousandSeperatorDecimalNumber,
  getQuantityValue,
  handleTransformClientInventoryJsonToDbFormat,
  batchStockPriceChange,
  getModalStockPriceColumn,
} from "../../utility";
import {
  DeleteIcon,
  EditIcon,
  LockIcon,
  UnLockIcon,
} from "../../../assets/icons/iconsProvider";

//-------column headers for the batch trade table
const getAddTradeBatchColumns = (props) => {
  const {
    productTags,
    currentStore,
    tradeinMargin,
    markupPresets,
    productDataObject,
    handleEmptyOnFocus,
    setEditTradeObject,
    setEditCustomProduct,
    toggleCustomItemModal,
    addTradeBatchInventory,
    handleAddTradeModalOpen,
    setAddTradeBatchInventory,
    setPriceChartingProductInfo,
    handleAddTradeBatchInventory,
    handleItemCashTradePercentage,
  } = props;

  //-------handle delete item from batch
  const onDeleteItem = (Id) => {
    const updatedInventory = addTradeBatchInventory.filter(
      (item) => item.id !== Id
    );

    handleAddTradeBatchInventory(
      updatedInventory?.map((item, index) => ({ ...item, id: index })) || []
    );
  };
  //-------handle onchnage any product quantity
  const onChangeQuantity = (newQuantity, Id) => {
    newQuantity = Number(newQuantity);
    const updatedInventory = addTradeBatchInventory.map((item) => {
      if (item.id === Id) {
        if (item.isSeparateQuantity) {
          return { ...item, onlineQuantity: newQuantity };
        } else {
          return { ...item, inStockQuantity: newQuantity };
        }
      }
      return item;
    });
    handleAddTradeBatchInventory(updatedInventory);
  };
  //-------handle onchnage of product cash offer
  const onChangeCashOffer = (newOffer, Id) => {
    // newOffer = Number(newOffer);
    const updatedInventory = addTradeBatchInventory.map((item) => {
      if (item.id === Id) {
        const ratio = calculateRatio(item);
        const tradeOfferPercentage = newOffer * ratio;
        return {
          ...item,
          tradeOffer: parseToDecimalNumber(tradeOfferPercentage),
          cashOffer: newOffer,
        };
      }
      return item;
    });
    handleAddTradeBatchInventory(
      handleItemCashTradePercentage(updatedInventory)
    );
  };
  //-------handle onchange product trade offer
  const onChangeTradeOffer = (newOffer, Id) => {
    // newOffer = Number(newOffer);
    const updatedInventory = addTradeBatchInventory.map((item) => {
      if (item.id === Id) {
        const ratio = calculateRatio(item);
        const cashOfferCalculated = newOffer / ratio;
        return {
          ...item,
          tradeOffer: newOffer,
          cashOffer: parseToDecimalNumber(cashOfferCalculated),
        };
      }
      return item;
    });
    handleAddTradeBatchInventory(
      handleItemCashTradePercentage(updatedInventory)
    );
  };
  //-------handle onchnage product stock price
  const onChangeStockPrice = (newPrice, Id) => {
    batchStockPriceChange(
      Id,
      newPrice,
      currentStore,
      markupPresets,
      addTradeBatchInventory,
      handleAddTradeBatchInventory
    );
  };
  //-------handle batch trade product edit button click
  const handleEditCardClick = (productDetail) => {
    if (productDetail?.apiSource === inventoryConstants.STORE_CUSTOM_PRODUCT) {
      setEditCustomProduct(productDetail);
      toggleCustomItemModal();
    } else {
      let updatedProductDetail = {
        ...productDetail,
        ...handleTransformClientInventoryJsonToDbFormat({ ...productDetail }),
        productObject: {
          ...productDetail.productObject,
          ...handleTransformClientInventoryJsonToDbFormat({
            ...productDetail.productObject,
          }),
        },
      };
      let condition = {
        label: updatedProductDetail.price.type,
        value: updatedProductDetail.price.type,
      };
      let productConditionList = productDetail.productConditionList;
      let updatedPriceChartingProductInfo = {
        productMetaData: {
          ...productDetail,
          condition,
          productCondition: condition,
          conditionList: productConditionList,
          productConditionList,
        },
        productObject: productDetail.productObject,
      };
      setEditTradeObject(updatedProductDetail);
      handleAddTradeModalOpen();
      setPriceChartingProductInfo(updatedPriceChartingProductInfo);
    }
  };

  let columns = [
    {
      id: "title",
      name: "Title",
      selector: (row) => row.productName,
      cell: (row) => {
        return (
          <div className="d-flex flex-column">
            <TableCustomHeader
              id={`tool${row.id}`}
              label={
                <span className="inventory-cell-max-size product-title-max-width">
                  {row.productName}
                </span>
              }
              toolTipText={row.productName}
            />
            {getProductSubCategory(row.genre) ===
              TRADING_CARD_CATEGORIES_ENUMS.SYSTEM &&
              (currentStore[
                toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY
              ] ||
                row?.serialNumber) && (
                <span
                  className={`${
                    row.serialNumber ? EMPTY_STRING : "text-danger"
                  } batch-seial-number-label`}
                >
                  S/N : {row?.serialNumber || "Required"}
                </span>
              )}
          </div>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    getBatchModalGradeColumn(
      addTradeBatchInventory,
      setAddTradeBatchInventory,
      currentStore?.id
    ),
    {
      id: "condition",
      name: "Condition",
      selector: (row) => row.productCondition,
      cell: (row) => {
        return (
          <SelectDropDown
            menuPlacement="bottom"
            options={row.productConditionList}
            noOptionsMessage="No Type Found"
            placeHolder="Type"
            defaultPageSize={{
              value: row?.productCondition,
              label: row?.productCondition,
            }}
            isDisabled={row?.isItemLocked}
            handleChange={(e) =>
              onChangeProductCondition(
                markupPresets,
                row.id,
                e.value,
                true,
                addTradeBatchInventory,
                handleAddTradeBatchInventory,
                tradeinMargin,
                handleItemCashTradePercentage
              )
            }
            menuPortalTarget=""
            value={{
              value: row?.productCondition,
              label: row?.productCondition,
            }}
          />
        );
      },
      sortable: false,
      sortDirection: null,
    },
    getBatchModalRarityColumn(
      addTradeBatchInventory,
      setAddTradeBatchInventory,
      currentStore?.id
    ),
    {
      id: "type",
      name: "Type",
      selector: (row) => row.productType,
      cell: (row) => {
        return (
          <span className="inventory-cell-max-size">{row.productType}</span>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "category",
      name: "Category",
      selector: (row) => row.consoleName,
      cell: (row) => {
        return (
          <span className="inventory-cell-max-size">{row.consoleName}</span>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "marketPrice",
      name: "Market Price",
      selector: (row) => row.marketPrice,
      cell: (row) => {
        return (
          <span
            className={`inventory-cell-max-size ${
              isMarketPriceHigh(
                row.marketPrice,
                row.inStockPrice,
                productTags,
                row.tags.map((tag) => tag.label),
                row.isDataFetching
              )
                ? "text-danger"
                : ""
            }`}
          >
            {parseToThousandSeperatorDecimalNumber(row.marketPrice)}
          </span>
        );
      },
      sortable: false,
      sortDirection: null,
      width: "8%",
    },
    {
      id: "quantity",
      name: "Quantity",
      selector: (row) => getQuantityValue(row, false),
      cell: (row) => {
        return (
          <SimpleNumberField
            minimumValue={0}
            step={1}
            isConvertToDecimal={false}
            key={row.id}
            value={getQuantityValue(row, false)}
            maxValue={inventoryConstants.THRESHOLD_MAX_CASH_VALUE}
            className=" max-input-width trade-batch-input-fields"
            onChange={(value) => {
              onChangeQuantity(value, row.id);
            }}
            isHandleKeyDown={true}
            disabled={
              (isSystemProduct(
                getProductSubCategory(productDataObject?.genre)
              ) &&
                currentStore[
                  toggleSwitchButtonConstants
                    .IS_SERIAL_NUMBER_REQUIRED_INVENTORY
                ]) ||
              row?.isItemLocked ||
              row?.serialNumber
            }
          />
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "Cash",
      name: "Cash",
      selector: (row) => row.cashOffer,
      cell: (row) => {
        return (
          <input
            key={row.cashOffer}
            min={0}
            type="number"
            defaultValue={row.cashOffer}
            // value={row.cashOffer}
            onFocus={handleEmptyOnFocus}
            // onChange={(e) => onChangeCashOffer(e.target.value, row.id)}
            className="input-textfield  editable-inventory-cell-max-size trade-batch-input-fields"
            onBlur={(e) => {
              const inputValue = parseToDecimalNumber(e.target.value); // Convert to number
              const prevValue = parseToDecimalNumber(row.cashOffer);
              inputValue !== prevValue && onChangeCashOffer(inputValue, row.id);
            }}
            disabled={row?.isItemLocked}
          ></input>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "Trade",
      name: "Trade",
      selector: (row) => row.tradeOffer,
      cell: (row) => {
        return (
          <input
            key={row.tradeOffer}
            defaultValue={row.tradeOffer}
            min={0}
            type="number"
            // value={row.tradeOffer}
            onFocus={handleEmptyOnFocus}
            className="input-textfield  editable-inventory-cell-max-size me-2 trade-batch-input-fields"
            // onChange={(e) => onChangeTradeOffer(e.target.value, row.id)}
            onBlur={(e) => {
              const inputValue = parseToDecimalNumber(e.target.value); // Convert to number
              const prevValue = parseToDecimalNumber(row.tradeOffer);
              inputValue !== prevValue &&
                onChangeTradeOffer(inputValue, row.id);
            }}
            disabled={row?.isItemLocked}
          ></input>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    getModalStockPriceColumn(
      currentStore,
      addTradeBatchInventory,
      handleAddTradeBatchInventory,
      productTags,
      handleEmptyOnFocus,
      markupPresets
    ),
    {
      id: "inStockPriceAnd",
      name: "",
      cell: (row) => {
        return getProductIfExist(row, onChangeStockPrice);
      },
      sortable: false,
      width: "8%",
    },
    {
      id: "action",
      name: "",
      cell: (row) => {
        return row?.isDataFetching ? (
          <div className="d-flex justify-content-center align-items-center">
            <RotatingLines
              visible={true}
              height="20"
              width="20"
              color="grey"
              strokeColor="#6a18ed"
              strokeWidth="4"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
            />
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper  ps-0 pe-0"
              onClick={() => onDeleteItem(row.id)}
            >
              <DeleteIcon className="cursor-pointer text-primary" />
            </button>{" "}
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper  ps-0 pe-0 mx-auto"
              onClick={() => {
                handleLockOrUnlockTradeItem(
                  currentStore,
                  addTradeBatchInventory,
                  setAddTradeBatchInventory,
                  row.id
                );
              }}
            >
              {row?.isItemLocked ? (
                <LockIcon className="cursor-pointer text-primary" />
              ) : (
                <UnLockIcon className="cursor-pointer " />
              )}
            </button>
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper ps-0 pe-0"
              onClick={() => {
                handleEditCardClick(row);
              }}
            >
              <EditIcon className="cursor-pointer text-primary" />
            </button>
            {/* delete icon button */}
          </div>
        );
      },
      sortable: false,
      width: "7%",
    },
  ];

  let filteredColumns = excludeNullColumns(columns);
  return filteredColumns;
};

export { getAddTradeBatchColumns };
